import React from 'react'
import { useUserStorage } from '../../../storage/user'
import './styles.css'
import { useGlobalCarteira } from '../../../storage/globalCarteira'

export default function InfoPainel() {

        
    const user2 = localStorage.getItem("user")
    const user = JSON.parse(user2)

    const { dataCarteira } = useGlobalCarteira(state => state)

    return (
        <div className='secondInfoPainelUser' style={{ height: '100px', padding: '50px 0 0 0', width: '100%' }}>

            {
                dataCarteira?.imagem ? <img src={dataCarteira?.imagem} style={{ width: '96px', height: '96px', background: '#3e64de', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50px' }} />
                    :
                    <div style={{ width: '96px', height: '96px', background: '#3e64de', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '50px' }}>
                        <h3 style={{ color: 'white' }}>{user.nome?.charAt(0)}</h3>
                    </div>
            }
            <div style={{ marginLeft: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                <h3>Olá! </h3>
                <h2>{user.nome || ''}</h2>
            </div>
        </div>
    )
}
